import React, { lazy, Suspense } from 'react';

const LazyRequestedListings = lazy(() => import('./RequestedListings'));

const RequestedListings = (props) => (
  <Suspense fallback={null}>
    <LazyRequestedListings {...props} />
  </Suspense>
);

export { RequestedListings };
